import { SupplierGroupSettingsMessage } from '../../../../../types/SupplierGroupSettingsMessage';
import { updateSupplierGroupSettings } from '../../../../common/api/clients/company.api';
import { queries } from '../../../../common/api/queryKeys/queries';
import { useOptimisticMutation } from '../../../../common/hooks/useOptimisticMutation';

export const useSupplierGroupSettingsOptimisticMutation = (supplierGroupId: string) => {
    const { mutate, ...rest } = useOptimisticMutation({
        mutationFn: updateSupplierGroupSettings,
        optimisticUpdateOptions: {
            queryKey: queries.supplierGroups.detail(supplierGroupId)._ctx.settings.queryKey,
            optimisticUpdatesFn: ({
                variables,
            }: {
                prevQueryData: SupplierGroupSettingsMessage;
                variables: {
                    groupId: string;
                    settings: SupplierGroupSettingsMessage;
                };
            }) => {
                return variables.settings;
            },
            invalidateQueryOnSuccess: true,
        },
    });

    const toggleEnforceMfa = (currentSettings: SupplierGroupSettingsMessage) => {
        mutate({
            groupId: supplierGroupId,
            settings: {
                ...currentSettings,
                supplierGroupId,
                enforceMfa: !currentSettings.enforceMfa,
            },
        });
    };

    return {
        ...rest,
        mutate,
        toggleEnforceMfa,
    };
};
